'use strong';
import React from 'react';
import ReactDOM from 'react-dom';
import { pageMountHoc } from './lib/page';
import { FullscreenSpinner } from './components/spinner';

import('./bootstrap');
export const Notification = pageMountHoc('Notification');
export const RoadmapBook = pageMountHoc(
  'RoadmapBook',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const RoadmapCourse = pageMountHoc(
  'RoadmapCourse',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const RoadmapEntry = pageMountHoc(
  'RoadmapEntry',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const Landing = pageMountHoc(
  'Landing',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const Curation = pageMountHoc(
  'Curation',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const EssentialCourse = pageMountHoc(
  'EssentialCourse',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const PremiumCourse = pageMountHoc(
  'PremiumCourse',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const Audio = pageMountHoc(
  'Audio',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const Pricing = pageMountHoc(
  'Pricing',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const PricingPlanParts = pageMountHoc(
  'PricingPlanParts',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
export const Auth = pageMountHoc(
  'Auth',
  <FullscreenSpinner backgroundColor="#FEFCF5" size={100} />
);
